// src/components/ChatHistoryPopup.tsx

import React, { useState } from "react";
import {
    Box,
    Typography,
    TextField,
    InputAdornment,
    Paper,
    ListItemButton,
} from "@mui/material";
import { 
    Search as SearchIcon, 
    CheckCircle as CheckCircleIcon  
} from "@mui/icons-material";

export interface ChatHistoryItem {
  id: string;
  prompt: string;
}

export const allChats: ChatHistoryItem[] = [
    { id: 'chat-1', prompt: "Today's Global News Headlines" },
    { id: 'chat-2', prompt: "How AI is helping in tech domains" },
    { id: 'chat-3', prompt: "AI Agents and their benefits" },
    { id: 'chat-4', prompt: "How to create AI agents" },
    // --- ADDED 2 HARDCODED QUESTIONS HERE ---
    { id: 'chat-5', prompt: "How to implement role-based access control (RBAC) in Node.js?" },
    { id: 'chat-6', prompt: "What are the best practices for Dockerizing a React application?" },
];

interface ChatHistoryPopupProps {
    onClose: () => void;
    onSelectChat: (chat: ChatHistoryItem) => void;
    selectedChatId: string; 
}

const ChatHistoryPopup: React.FC<ChatHistoryPopupProps> = ({ 
    onClose, 
    onSelectChat, 
    selectedChatId 
}) => {
    const [searchQuery, setSearchQuery] = useState("");

    const filteredChats = allChats.filter(chat => 
        chat.prompt.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <Box sx={{ p: 2, width: { xs: '280px', sm: '350px' } }}>
            <Typography
                variant="h6"
                sx={{
                    fontFamily: "Gilroy-SemiBold",
                    fontSize: '18px',
                    color: "#1F2937",
                    mb: 2,
                }}
            >
                Preview Chats
            </Typography>

            <TextField
                variant="outlined"
                placeholder="Search"
                fullWidth
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)} 
                sx={{
                    mb: 2,
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        fontFamily: 'Gilroy-Regular',
                        bgcolor: '#F9FAFB',
                        '& .MuiOutlinedInput-notchedOutline': { 
                            borderColor: '#E5E7EB' 
                        },
                    },
                    '& .MuiOutlinedInput-input': {
                        paddingTop: '12px', 
                        paddingBottom: '12px',
                    },
                }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon sx={{ color: '#101010' }} />
                        </InputAdornment>
                    ),
                }}
            />

            <Box>
                {filteredChats.map((chat) => {
                    const isSelected = chat.id === selectedChatId; 

                    return (
                        <Paper
                            key={chat.id}
                            elevation={0}
                            sx={{
                                border: '2px solid',
                                borderColor: isSelected ? '#19AF66' : '#E5E7EB',
                                borderRadius: '8px',
                                mb: 1.5,
                                position: 'relative', 
                                '&:hover': {
                                    borderColor: isSelected ? '#19AF66' : '#D1D5DB',
                                }
                            }}
                        >
                            <ListItemButton
                                onClick={() => {
                                    onSelectChat(chat); 
                                }}
                                sx={{
                                    fontFamily: 'Gilroy-Medium',
                                    fontSize: '14px',
                                    color: '#374151',
                                    borderRadius: '8px',
                                    p: '12px 16px',
                                }}
                            >
                                {chat.prompt}
                            </ListItemButton>

                            {isSelected && (
                                <CheckCircleIcon
                                    sx={{
                                        color: '#19AF66',
                                        position: 'absolute',
                                        top: -10, 
                                        right: -10, 
                                        fontSize: '20px',
                                    }}
                                />
                            )}
                        </Paper>
                    );
                })}
            </Box>
        </Box>
    );
};

export default ChatHistoryPopup;